<bb-overview-list [header]="header" [itemsJson]="displayedComponents | async"></bb-overview-list>
